export default "__VITE_ASSET__CZxuaWfS__"